<template>
    <div class="authorCenter">
        <Header></Header>
        <div class="authorBox flexible authorBox-big">
            <sidebar></sidebar>
            <div class="writewrap flex">
                <div class="right " v-loading="loading" style="overflow: auto">
                    <div class="chapter-title flexible aItem-center jc-between">
                        <div class="page-title font-MT ">
                            <!-- <img class="fh-img" src="@/assets/ic_fh.png" alt="" @click="goBack()"> -->
                            <span class="f22 page-name text-333 fwb-600">我的收益</span>
                        </div>
                    </div>
                    <!--<div class="con-data bank-collect">
                        <div class="label">重要！</div>
                        <div class="label-tip">由于部分作者开户行填写不完整无法打款，现开放快捷填写入口，以保障后续及时发放稿费！！！（如已修改请忽略）</div>
                        <el-form ref="form" class="create-form bank-form" :model="form">
                            <el-form-item label="开户行全称" prop="bank">
                                <div class="flexible">
                                    <el-input v-model="form.bank" placeholder="请输入您的开户行支行名称"></el-input>
                                    <el-button class="ml20 search-btn f14" @click="submitBank()">提交</el-button>
                                </div>
                                <div class="f12 text-muted">格式如：xx银行 XX省XX市XX县XX支行，填写完成后点击<router-link class="text-danger" to="/author/info">“这里”</router-link>查看</div>

                            </el-form-item>
                        </el-form>
                    </div>-->
                    <div class="f16 text-333 fwb-500 pt40 con-text">
                        收益提现
                    </div>
                    <div class="con-data">
                        <div class="f14 text-333 fwb-500">数据概览</div>
                        <div class="data-box flexible jc-between ">
                            <div>
                                <p class=" f12 text-666 fwb-400">总金额（税前）</p>
                                <p class="pt10"><span class="f18 text-333 fwb-600"
                                        style="padding-right:3px">{{ paylogdata && paylogdata.totalIncome ? paylogdata.totalIncome:'0.00' }}</span>元
                                </p>
                            </div>
                            <div>
                                <p class=" f12 text-666 fwb-400">可提现金额（税前）
                                    <el-popover class="top-pop" placement="right-start" width="320" trigger="click">
                                        <div style="line-height: 27px;padding:10px">
                                            <p class="f14 text-333">提现规则: </p>
                                            <p class="f14 text-333">1. 当你成为一名签约作者，你将开始获得收益。</p>
                                            <p class="f14 text-333">2. 收益余额达到100元，你就可以将收益提现。</p>
                                            <p class="f14 text-333">3. 提现产生的税费由作者按照税率政策承担。 </p>
                                            <p class="f14 text-333">4. 一个月只允许提现一次。</p>
                                        </div>
                                        <el-button style="padding:0;border:none;" class="tip-btn" slot="reference"><i
                                                class="el-icon-warning"></i></el-button>
                                    </el-popover>
                                </p>
                                <p class="pt10"><span class="f18 text-333 fwb-600"
                                        style="padding-right:3px">{{ paylogdata && paylogdata.allIncome ? paylogdata.allIncome:"0.00" }}</span>元
                                </p>
                                <el-popover popper-class="money-popper" class="top-pop mt10" placement="right-start"
                                    width="320" trigger="click" v-if="cashTable1 && cashTable1.length > 0">
                                    <div class="mx-box">
                                        <div v-for="item in cashTable1">
                                            <p class="f14 text-333 fwb-500" style="position: relative">
                                                {{ item.bookName }} <span
                                                    style="position: absolute;right: 20px;">+{{ item.money }}</span></p>
                                            <p class="f12 text-999 " style="margin-top:5px;">{{ item.createTime }}</p>
                                        </div>
                                    </div>
                                    <el-button style="padding:0;border:none;" class="tip-btn " slot="reference">查看明细>
                                    </el-button>
                                </el-popover>
<!--                                <p class="tx-btns">-->
<!--                                    <el-button class="txz-btn f14" v-if="paylogdata && paylogdata.writerCashStatus.value == 3">财务打款中-->
<!--                                    </el-button>-->
<!--                                    <el-button class="sqtx-btn" v-if="paylogdata && paylogdata.writerCashStatus.value == 0" @click="applywithdrawal">申请提现-->
<!--                                    </el-button>-->
<!--                                    <el-button class="sqtx-disbtn" v-if="paylogdata && paylogdata.writerCashStatus.value == -10">申请提现-->
<!--                                    </el-button>-->
<!--                                </p>-->

                            </div>
                            <div>
                                <p class=" f12 text-666 fwb-400">累计提现金额（税前）</p>
                                <p class="pt10"><span class="f18 text-333 fwb-600"
                                        style="padding-right:3px">{{ paylogdata && paylogdata.allPayedMoney?paylogdata.allPayedMoney:'0.00' }}</span>元
                                </p>
                                <el-popover popper-class="money-popper" class="top-pop mt10"  placement="left-start"
                                    width="500" trigger="click" v-if="cashTable2 && cashTable2.length > 0">
                                    <div class="mx-box">
                                        <div class="mx-box-item" v-for="item in cashTable2">
                                            <div class="f16 text-333 flexible jc-between">
                                                <div class="fwb-500">{{ item.money }}</div>
                                                <div class="fwb-500">提现成功</div>
                                            </div>
                                            <div class="f12 text-muted flexible jc-between mt5">
                                                <div>税费：{{item.tax}} 实际到账：{{item.paidMoney}}</div>
                                                <div>{{ item.updateTime }}</div>

                                            </div>
                                        </div>
                                    </div>
                                    <el-button style="padding:0;border:none;" class="tip-btn " slot="reference">查看明细>
                                    </el-button>
                                </el-popover>
                            </div>
                        </div>
                    </div>
                    <div class="f16 text-333 fwb-500 pt40 con-text">
                        数据趋势
                    </div>
                    <el-form :inline="true" class="income-form mt20">
                        <el-form-item>
                            <el-select v-model="queryParams.bookId" placeholder="请选择查看的作品" style="width:350px">
                                <el-option value="" label="所有作品"></el-option>
                                <el-option v-for="(i ,index) in bookList" :key="index" :value="i.id" :label="i.iname">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-date-picker v-model="time" type="daterange" range-separator="-" start-placeholder="开始时间"
                                end-placeholder="结束时间">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button class="ml20 search-btn f14" @click="getauthorCashlist()">搜索</el-button>
                        </el-form-item>
                    </el-form>
                    <!-- <incomeEcharts  v-if="paylogdata&&paylogdata.x_data.length >= 2" :chartData="paylogdata"></incomeEcharts> -->
                    <!--  -->
                    <el-table class="income-table" v-if="authorCashList && authorCashList.length > 0"
                        :data="authorCashList" stripe>
                        <el-table-column align="center" prop="bookName" label="作品名称"></el-table-column>
                        <el-table-column align="center" prop="money" label="收益"></el-table-column>
                        <el-table-column align="center" prop="typeDesc" label="作品类型">
                        </el-table-column>
                        <el-table-column align="center" prop="createTime" label="时间"></el-table-column>

                    </el-table>
                    <div class="datanull" v-if="!authorCashList || (authorCashList && authorCashList.length == 0)">
                        <img src="@/assets/author/no-data.png" />
                        <p>暂无数据</p>
                    </div>
                    <pagination class="fr" v-show="total>0" :total="total" :page.sync="queryParams.pageNo"
                        :limit.sync="queryParams.pageSize" @pagination="getauthorCashlist()" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //   import incomeEcharts from "./incomeEcharts";
    //   import {authorpayloglist, AuthorBookList, authorapply} from '@/api/author'
    import {
        getPaylogListApi,
        authorBookListApi,
        getPaylogUndrawnApi,
        getWriterListApi,
        writerCashApi,
        modifybank
    } from '@/api/author'
    import Pagination from "@/components/Pagination/index"
    import {
        formatDate
    } from '@/utils/index'
    export default {
        data() {
            return {
                chartData: {},
                // authorCashList: null,
                authorCashList: [],
                bookList: [],
                total: 0,
                queryParams: {
                    pageNo: 1,
                    pageSize: 50,
                    beginDate: '',
                    endDate: '',
                    bookId: ''
                },
                time: '',
                paylogdata: null,
                loading: false,
                cashTable1: [],
                cashTable2: [],
                form:{
                    bank:''
                },
                rules: {
                    bank: [{
                        required: true,
                        message: "请输入您的开户行支行名称",
                        trigger: "blur"
                    }],


                },
            }
        },
        created() {
            // console.log('income')
        },
        mounted() {
            // console.log('income')
            this.getCashList1()
            this.getCashList2()
            this.getAuthorBookList()
        },
        components: {
            Pagination
        },
        methods: {
            // 获取作品信息
            getAuthorBookList() {
                authorBookListApi({
                    pageNo: 1,
                    pageSize: 1000
                }).then(res => {
                    if (res.data.length == 0) {
                        this.bookList = []
                    } else {
                        this.bookList = res.data.items
                    }
                    if (this.bookList.length == 0) {
                        this.authorCashList = []
                    } else {
                        // this.queryParams.bookId = res.data.items[0].id
                        this.queryParams.beginDate = formatDate(new Date(), 'before', 7)
                        this.queryParams.endDate = formatDate(new Date(), 'date')
                        this.time = [formatDate(new Date(), 'before', 7), formatDate(new Date(), 'date')]
                        this.getauthorCashlist()
                    }
                })
            },
            // 数据查询
            getauthorCashlist() {
                this.queryParams.beginDate = formatDate(this.time[0], 'date')
                this.queryParams.endDate = formatDate(this.time[1], 'date')
                this.loading = true
                getPaylogListApi(this.queryParams).then(res => {
                    console.log(res)
                    this.loading = false
                    this.paylogdata = res.data
                    this.authorCashList = res.data.details.items
                    this.total = Number(res.data.details.totalCount)
                })
            },
            //可提现列表
            getCashList1() {
                getPaylogUndrawnApi().then(res => {
                    console.log(res)
                    if (res.data) {
                        this.cashTable1 = res.data
                    }
                })
            },
            getCashList2() {
                getWriterListApi().then(res => {
                    console.log(res)
                    if (res.data) {
                        this.cashTable2 = res.data
                    }
                })
            },
            // 申请提现
            applywithdrawal() {
                writerCashApi({}).then(res => {
                    console.log(res)
                    if (res.data) {
                        this.$success('custom', '申请提交成功!')
                        this.getCashList1()
                        this.getCashList2()
                        this.getAuthorBookList()
                        // this.paylogdata.inspectStatus.value = 1
                    }
                })
            },
            // 银行信心
            submitBank () {
                if (!this.form.bank) {
                    return false;
                }
                modifybank(this.qs.stringify({bank:this.form.bank})).then(res=>{
                    if (res.success) {
                        this.$success('custom', '提交成功!')
                    }
                })
            }
        }
    };
</script>
<style lang="scss">

    .money-popper{
        max-height: 600px !important;
        overflow-y: auto!important;
        overflow-x: hidden!important;
        .mx-box{
            .mx-box-item{
                border-bottom: 1px solid #EDEDED;
                padding: 10px 0;
            }
        }
    }
</style>
<style lang="scss" scoped>
    @import "@/styles/author.scss";

    .con-text {
        padding-bottom: 10px;
        border-bottom: 1px solid #F2F2F2;
    }

    .search-btn {
        width: 90px;
        height: 36px;
        // line-height: 36px;
        background: #F68A01;
        border-radius: 20px;
        border: none;
        color: #fff;

    }

    .con-data {
        height: 218px;
        background: #FBFBFB;
        border-radius: 4px;
        margin-top: 28px;
        padding: 30px;
        box-sizing: border-box;

        .data-box {
            padding: 20px 200px 0;

            &>div {
                text-align: center;
            }

            /deep/.tip-btn {
                display: inline-block;
                padding: 0 !important;
                color: #999 !important;
            }

            /deep/.tip-btn:hover,
            .tip-btn:focus {
                background: transparent !important;
                color: #999 !important;
            }

            .tx-btns {
                margin-top: 16px;

                /deep/.el-button {
                    width: 90px !important;
                    height: 32px !important;
                    line-height: 30px !important;
                    padding: 0 !important;
                    border: 1px solid #F68A01;
                    border-radius: 6px !important;
                }

            }

            .txz-btn {
                background: #F68A01 !important;
                color: #FFFFFF !important;
            }

            .txz-btn:hover,
            .txz-btn:focus {
                color: #fff;
            }

            .sqtx-btn {
                background: #FAF4EB !important;
                color: #F68A01 !important;
            }

            .sqtx-disbtn {
                background: #F5F5F5 !important;
                border: 1px solid #999999 !important;
                color: #999999 !important;
            }

        }
    }
    .bank-collect{
        .label{
            font-size: 18px;
            color: #F92B2B;
            font-weight: 600;
            line-height: 25px;
        }
        .label-tip{
            font-size: 14px;
            color: #F92B2B;
            font-weight: 500;
            line-height: 20px;
            margin-top: 7px;
        }
        .bank-form{
            margin-top: 15px!important;
            /deep/.el-input__inner{
                background: #ECECEC!important;
                border-color: #ECECEC!important;
                color: #333;
            }
        }
    }



    .income-form {

        /deep/.el-input__inner,
        /deep/.el-range-input {
            background: #F5F6F7;
            border-color: #F5F6F7;
            color: #333;
        }

        .cross-line {
            color: #979797;
        }
    }

    .income-table {
        border: 1px solid #E6E6E6;
        border-right: none;
        margin-top: 50px;

        /deep/th {
            background: #E6E6E6 !important;
            color: #333 !important;
        }

        /deep/th,
        /deep/td {
            font-size: 16px !important;
            font-family: Arial !important;
            border-right: 1px solid #F2F2F2 !important;
        }

        // /deep/td:hover {
        //     background: #fff !important;
        // }

        /deep/td:last-child {
            border-right: 1px solid #E6E6E6 !important;
        }

        /deep/td {
            color: #333 !important;
        }

        /deep/ tr.el-table__row--striped td.el-table__cell {
            background: #E9F2E6 !important;
        }
    }

    /deep/.el-pager li.active {
        // background: #7DB36C!important;
    }

</style>
